<template>
  <div class="col-12 white-bg">
    <Collapsable @openCollapsable="toggleCollapsible" :collapsableOpen="openCollapsable">
      <template v-slot:header>
        <div class="h4n">
          <div class="col-10 inline-block">
            <strong>Participant: </strong>{{ participant.firstName }}
            {{ participant.lastName }}
          </div>
        </div>
      </template>
      <template v-slot:content>
        <div class="col-12 collapsible mt2">
          <div>
            <Loader v-if="loadingSessions" class="flex" />
            <div v-else class="content flex flex-column">
              <div class="flex flex-wrap col-12 justify-start">
                <div class="no-box flex flex-wrap justify-center">
                  <!-- Select Contract -->
                  <CustomSelect
                    class="mx1 py1"
                    :options="contractOptions"
                    :default="selectedContract"
                    @input="selectedContract = $event"
                  />
                </div>
              </div>
              <div
                v-if="sessions.length"
                class="flex flex-column flex-grow sessions mt2"
              >
                <div
                  v-for="(session, index) in sessionsToShow"
                  :key="`${session.qrcode}-${session.activityCode}-${index}`"
                  class="flex col-12 flex-grow flex-wrap p2 items-center"
                >
                  <ScheduledSession
                    :session="session"
                    :participant="participant.uuid"
                    :contract="session.contractNumber"
                  />
                </div>
                <!-- CTA to show all -->
                <div v-if="showMoreSessions" class="flex flex-wrap justify-center m2">
                  <div @click="expandedSessions = true; toggleCollapsible(true);" class="pointer white red-btn col-6 md-col-6 lg-col-4 sm-col-6 px2 inline-block">
                    <div class="lg-my2 center md-xs-h5n semi-bold lg-col-12 caps-text xs-justify-center xs-col-4">
                      <span class="">Voir plus</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="col-12 flex flex-grow p2 full-height items-center">
                Vous n'avez pas encore réservé de cours
                <!-- {{ selectedOption === "Semaine" ? "cette semaine" : "ce jour" }}. -->
              </div>
            </div>
          </div>
        </div>
      </template>
    </Collapsable>
  </div>
</template>
<script>
import { ref, watch, nextTick, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';

import {
  differenceInWeeks,
  differenceInDays,
  format,
  parseISO,
  startOfDay,
  startOfWeek
} from 'date-fns';
import Loader from '@/components/common/Loader';
import ScheduledSession from '@/components/reservations/ScheduledSession';
import WeekNavbar from '@/components/reservations/WeekNavbar';
import CustomSelect from '@/components/common/CustomSelect';
  import Collapsable from '@/components/common/Collapsable';

import { getScheduledReservations } from '@/mixins/requests';

export default {
  components: { Loader, ScheduledSession, WeekNavbar, CustomSelect, Collapsable },
  props: ['participant', 'firstParticipant'],
  setup (props) {
    const store = useStore();
    const openedParticipants = computed(() => store.state.openedParticipants || []);
    const isOpen = ref(false);
    const loadingSessions = ref(false);
    const selectedOption = ref('Semaine');
    const selectedContract = ref({
      label: 'Produit',
      value: null
    });
    const openCollapsable = ref(false)
    const sessions = computed(() => {
      let sessionsAux = [...props.participant.sessions] || [];
      if (selectedContract.value.value !== null) {
        sessionsAux = sessionsAux.filter(session => session.contractNumber === selectedContract.value.value);
      }
      sessionsAux.sort((a, b) => {
        let compare = a.startTimestamp - b.startTimestamp
        if (!compare) {
            compare = a.endTimestamp - b.endTimestamp;
            if (!compare) {
                compare = a.type.localeCompare(b.type)
            }
        }
        return compare;
      })
      return sessionsAux
    });
    const contractOptions = computed(() => {
      const contracts = [{
        label: 'Produit',
        value: null
      }];
      if (props.participant.sessions && props.participant.sessions.length) {
        props.participant.sessions.map(session => {
          if (!contracts.some(contract => contract.value === session.contractNumber)) {
            contracts.push({
              label: session.product,
              value: session.contractNumber
            });
          }
        });
      }
      return contracts;
    });
    const isDaily = computed(() => selectedOption.value === 'Jour');
    const calendarDay = computed(() => {
      const date = store.getters.calendarDay(props.participant.uuid);
      if (!date) {
        return parseISO(format(startOfDay(new Date()), 'yyyy-MM-dd'));
      }

      return parseISO(format(startOfDay(new Date(date)), 'yyyy-MM-dd'));
    });
    const weekOffset = computed(() => differenceInWeeks(startOfWeek(calendarDay.value, { weekStartsOn: 1 }), startOfWeek(new Date(), { weekStartsOn: 1 })));
    const dayOffset = computed(() => differenceInDays(calendarDay.value, startOfDay(new Date())));
    const workspace = computed(() => store.state.siteInfo.workspace);
    
    const expandedSessions = ref(false)
    const showMoreSessions = computed(() => sessions.value && sessions.value.length > 4 && !expandedSessions.value)
    const sessionsToShow = computed(()=>{
        return showMoreSessions.value ? sessions.value.slice(0,4) : sessions.value;
    })

    const toggleCollapsible = (isCollapsableOpen) => {
      store.commit('removeOpenedParticipant', props.participant.uuid);
      if (isCollapsableOpen) {
        store.commit('addOpenedParticipant', props.participant.uuid);
      }
      // const element = document.querySelector(
      //   `#details-${props.participant.uuid}`
      // );
      // store.commit('removeOpenedParticipant', props.participant.uuid);
      // if (isOpen.value && !forceOpen) {
      //   element.style.height = '0px';
      // } else {
      //  nextTick(()=>{;
      //   store.commit('addOpenedParticipant', props.participant.uuid);
      //   const content = document.querySelector(
      //     `#details-content-${props.participant.uuid}`
      //   );
      //   element.style.height = `${content.offsetHeight}px`;
      //  })
      // }

      // isOpen.value = forceOpen || !isOpen.value;
    };

    const getReservations = async (start, end) => {
      loadingSessions.value = true;
      await getScheduledReservations({
        uuid: props.participant.uuid,
        isDaily: isDaily.value,
        workspace: workspace.value
      })
        .then(res => {
          props.participant.sessions = res[0].sessions;
        })
        .catch(err => {
          console.log('err: ', err);
          props.participant.sessions = [];
        })
        .finally(() => {
          loadingSessions.value = false;
        });
      toggleCollapsible(true);
    };

    const changeTime = async (start, end) => {
      await getReservations(start, end);
    };

    // watch(selectedOption, async (newValue, oldValue) => {
    //   selectedOption.value = newValue;
    //   await getReservations();
    // });

    watch(selectedContract, async (newValue, oldValue) => {
      expandedSessions.value = false;
      selectedContract.value = newValue;
      toggleCollapsible(true);
    });

    onBeforeMount(() => {
      openCollapsable.value = openedParticipants.value.includes(props.participant.uuid) || props.firstParticipant;
    });
    return {
      openCollapsable,
      isOpen,
      selectedOption,
      selectedContract,
      loadingSessions,
      contractOptions,
      sessionsToShow,
      showMoreSessions,
      sessions,
      expandedSessions,
      toggleCollapsible,
      changeTime
    };
  }
};
</script>
<style lang="scss">
.participant-header:hover {
  background-color: #aaa;
}
.content {
  min-height: 190px;
}
.sessions {
  > div:first-child {
    border-top: 1px solid #c8cdd273;
  }
  > div:not(:last-child) {
    border-bottom: 1px solid #c8cdd273;
  }
}
</style>